import { get } from "lodash";

export const GET_CURRENT_ORGANISATION_ID = "GET_CURRENT_ORGANISATION_ID";
export const GET_USER_DATA = "GET_USER_DATA";

const getters = {
  [GET_CURRENT_ORGANISATION_ID]: state =>
    get(state, "userData.organisation.id"),
  [GET_USER_DATA]: state => get(state, "userData")
};

export default getters;
